"use client";

import { usePathname } from "next/navigation";
import type { ReactNode } from "react";

/**
 * Wraps page content with a per-route fade-in animation. The pathname is
 * used as the React key so the wrapper unmounts/remounts on navigation,
 * re-firing the `.page-fade` CSS animation (~220ms opacity + slight slide).
 */
export function PageFade({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  return (
    <div key={pathname} className="page-fade">
      {children}
    </div>
  );
}
